import { render, staticRenderFns } from "./CreateServiceForm.vue?vue&type=template&id=c099ad24&scoped=true&"
import script from "./CreateServiceForm.vue?vue&type=script&lang=ts&"
export * from "./CreateServiceForm.vue?vue&type=script&lang=ts&"
import style0 from "./CreateServiceForm.vue?vue&type=style&index=0&id=c099ad24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c099ad24",
  null
  
)

export default component.exports